// extracted by mini-css-extract-plugin
export var dot = "_qa-2";
export var wave = "_qa-0";
export var waveSmall = "_qa-1";